/* lp-how-feral — built by feral·landers. Edit landers/how-feral/page.js, not this. */
(function(){"use strict";var LP_ROOT="#lp-how-feral",LP_NAME="how-feral";
/* ═══════════════════════════════════════════════════════════════════════════
   feral·landers — base.js
   Wrapped in one IIFE by kit/build.mjs, which also injects LP_ROOT and LP_NAME.
   A lander's own page.js runs after this and can use everything below.
   No framework, no modules — this is a theme asset and it has to run alone.
   ═══════════════════════════════════════════════════════════════════════════ */

var LP = {};
var root = document.querySelector(LP_ROOT);
if (!root) return;                       // the section is not on this page

var $  = function (sel, ctx) { return (ctx || root).querySelector(sel); };
var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var isPhone = function () { return window.matchMedia('(max-width: 989px)').matches; };

LP.root = root; LP.$ = $; LP.$$ = $$; LP.reduced = reduced; LP.isPhone = isPhone;

/* Everything the data bridge hands us came out of Shopify admin, where a product
   title legitimately contains & and quotes. Escape before it touches innerHTML. */
function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
LP.esc = esc;

/* ── THE DATA BRIDGE ──────────────────────────────────────────────────────
   The ~30 lines of Liquid in the section shell emit live product data as JSON:
   variant ids, size labels, availability and PRICES ALREADY RENDERED BY THE
   SERVER in the visitor's market currency.
   🚨 Never format money in here. Shopify does not currency-convert a number you
   typed; the server's string is the only one that is definitely true, and a
   client that cannot convert must do nothing rather than show GBP.
   (part: server-honest-money-fx-upgrade)                                     */
LP.data = (function () {
  var el = document.getElementById('lp-' + LP_NAME + '-data');
  if (!el) return { products: {}, settings: {} };
  try { return JSON.parse(el.textContent); } catch (e) { return { products: {}, settings: {} }; }
})();
LP.product = function (key) { return LP.data.products && LP.data.products[key]; };

document.body.classList.add('lp-live');

/* ── PORTAL ───────────────────────────────────────────────────────────────
   🚨 The lander root sets `overflow-x: clip`, and in Safari ANY ancestor with
   overflow clip/hidden, a transform or a filter kills `position: fixed` — the
   element scrolls with the page. Invisible on desktop Chrome. So anything fixed
   is moved out to <body> before it is ever shown.
   (part: fixed-dock-outside-the-clip-ancestor · portal-overlay-to-body)      */
LP.portal = function (el) { if (el && el.parentNode !== document.body) document.body.appendChild(el); return el; };
$$('[data-lp-portal]').forEach(LP.portal);

/* ── THE THEME CHROME IS A MOVING TARGET ──────────────────────────────────
   Two stacked sticky layers (marquee at top:0, header at top:32px) and the group
   COLLAPSES on scroll: 105px at rest, 73px in motion. A hardcoded number is
   wrong half the time.
   🚨 The collapse is a CSS transition, so it finishes AFTER the last scroll
   event — one reading latches a stale value and a full-height band scrolls
   through the gap. Re-measure at ~200ms and ~500ms after scrolling stops.     */
(function chrome() {
  var group = document.querySelector('.shopify-section-group-header-group') ||
              document.querySelector('#shopify-section-header') ||
              document.querySelector('header');
  if (!group) return;
  var write = function () {
    var b = group.getBoundingClientRect().bottom;
    root.style.setProperty('--lp-chrome', Math.max(0, Math.round(b)) + 'px');
  };
  var t1, t2;
  var onScroll = function () {
    write();
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(write, 200);
    t2 = setTimeout(write, 500);
  };
  write();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(write);
})();

/* ── REVEALS ──────────────────────────────────────────────────────────────
   Arms only once we know JS is alive, so a script failure leaves a readable
   page rather than a blank one. Nothing in the first viewport is armed: it
   would fade in on load, read as a slow page, and cost LCP on the one element
   that matters most.                                                          */
(function reveals() {
  var items = $$('.lp-rv');
  if (!items.length || !('IntersectionObserver' in window)) return;
  var fold = window.innerHeight;
  var below = items.filter(function (el) { return el.getBoundingClientRect().top > fold * 0.9; });
  if (!below.length) return;
  root.classList.add('is-armed');
  items.forEach(function (el) { if (below.indexOf(el) < 0) el.classList.add('is-in'); });
  if (reduced) { below.forEach(function (el) { el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.02 });
  below.forEach(function (el) { io.observe(el); });
})();

/* ── THE CART ─────────────────────────────────────────────────────────────
   The proven add-from-anywhere flow, lifted from assets/feral-plp.js.
   🚨 Send it FORM-ENCODED and ask for the drawer sections in the SAME request.
   A JSON body with {items:[…]} genuinely lands the line item and still leaves
   the drawer painting its cached empty state — /cart.js says the item is there
   while the drawer says BAG EMPTY. That is the signature of bypassing the
   section render. (part: cart-add-with-section-rerender)
   The Meta CAPI layer in snippets/feral-events.liquid patches window.fetch and
   fires AddToCart off /cart/add.js by itself — do not emit a second event.    */
var inflight = false;
LP.addToCart = function (items) {
  if (inflight) return Promise.resolve(null);
  inflight = true;
  var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  var fd = new FormData();
  items.forEach(function (it, i) {
    fd.append('items[' + i + '][id]', String(it.id));
    fd.append('items[' + i + '][quantity]', String(it.quantity || 1));
  });
  if (cart && typeof cart.getSectionsToRender === 'function') {
    fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    fd.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
  }
  var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
  return fetch(url, {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    body: fd
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      // Shopify returns a JSON body with `status` for a sold-out variant even
      // when the HTTP status is inconsistently 200.
      if (data.status) throw new Error(data.description || data.message || 'add failed');
      if (cart) {
        // Remove is-empty or the drawer keeps painting its empty state over
        // correct contents. Do NOT open the drawer by hand — renderContents
        // already opens it, and doing both fights the transition.
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof cart.renderContents === 'function') cart.renderContents(data);
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lp-' + LP_NAME, cartData: data });
      }
      return data;
    })
    .finally(function () { inflight = false; });
};

/* ── THE SIZE SHEET ───────────────────────────────────────────────────────
   One sheet, portalled to <body>, populated per-call. Mobile gets a bottom
   sheet, desktop the same node centred (CSS decides) — a bottom sheet on a
   1440px screen is a modal for no reason, and an inline shake on a phone
   happens off-screen.
   The sold-out row stays FOCUSABLE and readable rather than disabled: a
   disabled control is invisible to a screen reader's tab order and throws away
   the most valuable moment on the page — someone who wants a thing you do not
   have. (part: the-buy-box-is-one-pill-in-three-states)                       */
var sheet, scrim, lastFocus;
function ensureSheet() {
  if (sheet) return;
  scrim = document.createElement('div');
  scrim.className = 'lp-sheet-scrim';
  sheet = document.createElement('div');
  sheet.className = 'lp-sheet';
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  sheet.setAttribute('aria-label', 'Choose a size');
  document.body.appendChild(scrim);
  document.body.appendChild(sheet);
  scrim.addEventListener('click', closeSheet);
  addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
}
function closeSheet() {
  if (!sheet) return;
  sheet.classList.remove('is-open');
  scrim.classList.remove('is-open');
  document.body.classList.remove('lp-locked');
  if (lastFocus && lastFocus.focus) lastFocus.focus();
}
LP.closeSheet = closeSheet;

/**
 * LP.pickSize(productKey, onPick) — onPick(variant) when a size is chosen.
 * Returns false and does nothing if the product is not in the data bridge.
 */
LP.pickSize = function (key, onPick) {
  var p = LP.product(key);
  if (!p) return false;
  ensureSheet();
  lastFocus = document.activeElement;
  var rows = p.variants.map(function (v) {
    var cls = 'lp-sheet__row' + (v.available ? '' : ' is-out');
    var right = v.available
      ? (v.low ? '<span class="lp-sheet__low">low stock</span>' : '')
      : '<span class="lp-sheet__out">sold out</span>';
    return '<button type="button" class="' + cls + '" data-vid="' + v.id + '"' +
           (v.available ? '' : ' data-out="1"') + '>' +
           '<span class="lp-sheet__size">' + esc(v.title) + '</span>' + right + '</button>';
  }).join('');
  sheet.innerHTML =
    '<div class="lp-sheet__head">' +
      '<div><div class="lp-sheet__eyebrow">' + esc(p.eyebrow) + '</div>' +
      '<div class="lp-sheet__title">' + esc(p.title) + '</div></div>' +
      '<button type="button" class="lp-sheet__x" aria-label="Close">&#10005;</button>' +
    '</div>' +
    '<div class="lp-sheet__grid">' + rows + '</div>' +
    '<a class="lp-sheet__link" href="' + esc(p.url) + '">Size guide and full detail &#8599;</a>';
  sheet.querySelector('.lp-sheet__x').addEventListener('click', closeSheet);
  Array.prototype.forEach.call(sheet.querySelectorAll('.lp-sheet__row'), function (b) {
    b.addEventListener('click', function () {
      if (b.getAttribute('data-out')) { window.location.href = p.url; return; }
      var v = p.variants.filter(function (x) { return String(x.id) === b.getAttribute('data-vid'); })[0];
      closeSheet();
      onPick(v);
    });
  });
  scrim.classList.add('is-open');
  sheet.classList.add('is-open');
  if (isPhone()) document.body.classList.add('lp-locked');
  // Focus the DIALOG, not the first size. `.focus()` on a row trips the
  // :focus-visible heuristics even from a tap, so the first size lights up with
  // a ring and reads as already chosen — on the one control where "nothing is
  // chosen yet" is the whole point. (part: size-deselected-until-the-url-picks-one)
  sheet.setAttribute('tabindex', '-1');
  sheet.focus();
  return true;
};

/* ── THE DOCK ─────────────────────────────────────────────────────────────
   Raised once the hero is behind you, so it never covers the first CTA.       */
LP.dockOn = function (afterEl) {
  var dock = document.querySelector('.lp-dock');   // portalled to <body>, so query the document
  if (!dock || !afterEl) return;
  if (!('IntersectionObserver' in window)) { dock.classList.add('is-up'); return; }
  new IntersectionObserver(function (e) {
    dock.classList.toggle('is-up', !e[0].isIntersecting);
  }, { threshold: 0 }).observe(afterEl);
};

/* Smooth in-page jumps that respect reduced motion. */
LP.jumpTo = function (el) {
  if (!el) return;
  el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
};
$$('[data-lp-jump]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    var target = $(a.getAttribute('data-lp-jump'));
    if (!target) return;
    e.preventDefault();
    LP.jumpTo(target);
  });
});

window.LP = LP;

/* HOW FERAL R U — page.js. Runs after the kit's base.js (LP, $, $$ are live).
   ONE state object paints the whole page, so a real customer and the preview
   switcher go down the same code path and cannot drift apart.
   Built ONCE: the climb, the table, the try-it chips, the small print.
   Painted PER STATE: the hero, the state chips, the lit column, the dock. */

var S = LP.data.settings || {};
var X = LP.data.extras || {};
var C = S.copy || {};
var LEVELS = S.levels || [];
var BEN = S.benefits || { groups: [], rows: [] };
var SECRET = S.secret || null;
var EVERY = (S.drops && S.drops.every_pct) || 20;
var PER = S.gbp_per_pct || 5;
var Rewards = window.HFRewards;
var Access = window.HFMemberAccess;
var esc = LP.esc;
var el = function (k) { return document.querySelector('[data-hf="' + k + '"]'); };
var all = function (sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); };
/* a key the caller did not pass falls back to the page-wide WORDS (names, gates, rates) */
var fill = function (s, o) { o = o || {}; return String(s || '').replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : typeof WORDS !== 'undefined' && WORDS[k] != null ? WORDS[k] : ''; }); };
var pad = function (n) { return (n < 10 ? '0' : '') + n; };
var mq = function (q) { return !!(window.matchMedia && matchMedia(q).matches); };
var CALM = mq('(prefers-reduced-motion: reduce)');
var FINE = mq('(hover: hover) and (pointer: fine)');
var motionPaused = false, motionObserver = null, motionFrame = 0;
try { motionPaused = localStorage.getItem('hf:motion-paused') === '1'; } catch (_) {}
function calmCards() { return CALM || motionPaused; }

/* A preview theme only. 'main' is the live theme; a blank or unknown role also
   builds nothing, so this fails closed. */
var PREVIEW = ['unpublished', 'development', 'demo'].indexOf(X.theme_role) !== -1;
if (PREVIEW) document.title = 'HOW FERAL R U · preview';

/* Credit is only ever said in a currency the server gave us a figure for: a visitor in any
   other currency never reads a credit amount, because theirs is held for review. SPEND is
   different. The engine counts it in GBP, so a gate or a distance falls back to £, which
   is the rule itself, never a hole or a %. (v3.3, 25 Sep: gates in money, never %.) */
var perPct = +X.per_pct || 0, FX = +X.fx || 0, DROP_N = +X.drop_n || 0;
var LOCAL = !!(perPct && X.sym);
function money(pct) { return perPct && X.sym ? X.sym + Math.ceil(pct * perPct - 1e-9) : ''; }
function gbp(n) { return '£' + Math.ceil(n - 1e-9); }
/* spend, which always has a figure: local when we have one, else the GBP the engine counts */
function cash(pct) { return money(pct) || gbp(pct * PER); }
function gift(gbp) { return FX && X.sym ? X.sym + Math.round(gbp * FX) : ''; }
/* What is left to spend before a point on the scale. A real member's audited pence, not the
   rounded-down %, so the distance never overstates by up to a unit. */
function spendTo(pct, from) {
  from = from || state;
  var have = from && from.net_minor != null ? from.net_minor / 100 : ((from && from.pct) || 0) * PER, left = Math.max(0, pct * PER - have);
  return LOCAL ? X.sym + Math.max(1, Math.ceil(left * perPct / PER - 1e-9)) : gbp(Math.max(1, left));
}
var WORDS = { unit: X.unit || gbp(PER), drop: X.drop || gbp(+(((S.drops && S.drops.value) || {}).GBP) || PER), every: EVERY, spend: cash(EVERY), days: (S.drops && S.drops.expires_days) || '', clears: (S.drops && S.drops.clears_days) || '' };
/* Credit back is the unit times the level's multiplier: the engine refuses rules where the
   back row and the multiplier disagree, so the page can read either. */
function times(key) { return ((S.drops && S.drops.multiplier) || {})[key] || 1; }
/* The small print is in GBP and read straight off the rules, so it cannot say a gate or an
   amount the engine does not pay. */
(function () {
  var unit = +((S.drops && S.drops.value) || {}).GBP || 0;
  WORDS.gbp_per_pct = PER; WORDS.gbp_spend = gbp(EVERY * PER);
  LEVELS.forEach(function (l) {
    WORDS['label_' + l.key] = l.label;
    WORDS['gate_' + l.key] = l.min_pct; WORDS['gbp_gate_' + l.key] = gbp(l.min_pct * PER); WORDS['l_gate_' + l.key] = cash(l.min_pct);
    if (unit) {
      WORDS['gbp_back_' + l.key] = gbp(unit * times(l.key)); WORDS['pct_back_' + l.key] = Math.round(unit * times(l.key) / (EVERY * PER) * 100);
      WORDS['l_back_' + l.key] = X.sym && DROP_N ? X.sym + DROP_N * times(l.key) : WORDS['gbp_back_' + l.key];
    }
  });
  var up = rowByKey('levelup');
  if (up) Object.keys(up.at || {}).forEach(function (k) { if (up.at[k].gbp) { WORDS['gbp_gift_' + k] = gbp(up.at[k].gbp); WORDS['l_gift_' + k] = gift(up.at[k].gbp) || WORDS['gbp_gift_' + k]; } });
})();

/* Same rule as the engine: the highest level whose gate is met. */
function levelFrom(pct, orders) {
  var at = 0;
  LEVELS.forEach(function (l, i) { if ((!l.requires_order || orders >= 1) && pct >= l.min_pct) at = i; });
  return at;
}
function levelIndex(key) { for (var i = 0; i < LEVELS.length; i++) if (LEVELS[i].key === key) return i; return -1; }

/* The audited ledger is the only score source. No tax-inclusive Shopify total
   can masquerade as eligible spend. Missing data has an explicit pending state. */
function realState() {
  if (!X.logged_in) return { guest: true };
  var known = X.mf_net_minor !== '' && X.mf_net_minor != null && Number.isSafeInteger(+X.mf_net_minor) && +X.mf_net_minor >= 0
    && X.mf_orders !== '' && X.mf_orders != null && Number.isSafeInteger(+X.mf_orders) && +X.mf_orders >= 0
    && levelIndex(X.mf_level)>=0 && X.mf_drop_cursor!=='' && X.mf_drop_cursor!=null && Number.isSafeInteger(+X.mf_drop_cursor) && +X.mf_drop_cursor>=0;
  if (!known) return { guest: true, pending: true, name: X.first_name || '', since: X.since || '', credit: X.credit || '' };
  var snapshot = Rewards.state(S, {net_minor: +X.mf_net_minor, orders: +X.mf_orders, level: Math.max(0, levelIndex(X.mf_level)), drop_cursor: +X.mf_drop_cursor || 0});
  return Object.assign(snapshot, {name: (X.first_name || '').toLowerCase(), since: X.since || '', credit: X.credit || ''});
}

var DEMO = [
  { guest: true, tag: 'logged out' },
  { name: 'harry', since: '2026', pct: 0, orders: 0, level: 0 },
  { name: 'harry', since: '2025', pct: 14, orders: 1, level: 1 },
  { name: 'harry', since: '2024', pct: 38, orders: 3, level: 2, credit: 5 },
  { name: 'harry', since: '2023', pct: 72, orders: 6, level: 3, credit: 10 },
  { name: 'harry', since: '2022', pct: 100, orders: 9, level: 4 },
  { name: 'harry', since: '2021', pct: 137, orders: 12, level: 4, tag: 'off the scale' },
  { name: 'harry', since: '2024', pct: 12, orders: 3, level: 2, drop_cursor: 2, tag: 'after a return' },
  { guest: true, pending: true, tag: 'history syncing' }
];

var state = realState();
var scramble = 0;
var tried = 0;
var exploreAt = 2;

/* ── WHAT A LEVEL GETS ──────────────────────────────────────────────────────
   A row says what it is AT a level; a level with no entry of its own keeps the
   one from the nearest level below. So the table and the chapters are two views
   of one list and cannot disagree. */
function entry(row, i) {
  for (var k = i; k >= 0; k--) { var e = (row.at || {})[(LEVELS[k] || {}).key]; if (e) return e; }
  return null;
}
/* What a level adds, the one it leads with first (`hero` in the rules). */
function perksAt(i) {
  var key = (LEVELS[i] || {}).key, out = [];
  BEN.rows.forEach(function (row) { var e = (row.at || {})[key]; if (e) { e._k = row.key; out.push(e); } });
  return out.filter(function (e) { return e.hero; }).concat(out.filter(function (e) { return !e.hero; }));
}
function backAmt(e) { return e._k === 'back' && X.sym && DROP_N ? X.sym + DROP_N * (e.x || 1) : ''; }
function perkAmt(e) { return e.gbp ? gift(e.gbp) : ''; }
function wordsFor(e) { return Object.assign({}, WORDS, { back: backAmt(e), gift: perkAmt(e) }); }
/* a title or note that needs money nobody gave us falls back to its plain form */
var NEEDS_MONEY = /\{(back|gift|spend)\}/;
function perkTitle(e) { var w = wordsFor(e); return NEEDS_MONEY.test(e.t || '') && !(w.back || w.gift) ? (e.s || '') : fill(e.t, w); }
function perkNote(e) { var w = wordsFor(e); return fill((NEEDS_MONEY.test(e.n || '') && !(w.back || w.gift) && e.n_plain) || e.n, w); }
function rowByKey(k) { for (var i = 0; i < BEN.rows.length; i++) if (BEN.rows[i].key === k) return BEN.rows[i]; return null; }

/* ── REWARDS AND PERKS. Money rows are rewards (store credit); access rows are perks (first
   go). The card is neither: it is the membership, drawn at the top. One list shape is used
   everywhere a level's contents are read: the hero's next level, ur rewards and perks, and
   each chapter. `_mark` says what changed at the level: new, or up from the level below. */
var KIND = { money: 'rewards', access: 'perks' };
function haveAt(i) {
  var out = { rewards: [], perks: [] }, key = (LEVELS[i] || {}).key;
  BEN.rows.forEach(function (row) {
    var k = KIND[row.group], e = entry(row, i); if (!k || !e) return;
    var own = (row.at || {})[key], was = i > 0 ? entry(row, i - 1) : null;
    /* an arrival gift is a gift of its own, never an upgrade of the one below */
    var up = own && was && row.key !== 'levelup';
    out[k].push(Object.assign({}, e, { _k: row.key, _mark: own ? (up ? 'up' : 'new') : '', _was: up ? Object.assign({}, was, { _k: row.key }) : null }));
  });
  return out;
}
function addsAt(i) {
  var h = haveAt(i), mine = function (e) { return e._mark; };
  return { rewards: h.rewards.filter(mine), perks: h.perks.filter(mine) };
}
/* money back is a rate: its figure is the rate ("5%") and its line is the row's name, so a
   level never pairs a spend gate with a per-£100 amount (Harry, 25 Sep). */
function rateOf(e) { return typeof e.v === 'string' && /^\d/.test(e.v) ? e.v : ''; }
function shortTitle(e) {
  var row = e._k === 'back' ? rowByKey('back') : null, per = (C.kinds || {}).per;
  if (row) return row.label + (per ? ' ' + fill(per, WORDS) : '');
  return fill(e.s || e.t, WORDS);
}
function figText(e) { return (e._k === 'back' ? rateOf(e) : perkAmt(e)) || rateOf(e); }
function haveHtml(e, notes) {
  var K = C.kinds || {}, mark = e._mark === 'up' && figText(e._was) ? fill(K.up, { was: figText(e._was) }) : e._mark === 'new' ? K['new'] : '';
  return '<li class="hf-have">' + figure(e) + '<span class="hf-have__t">' + esc(shortTitle(e)) + (mark ? ' <i class="hf-have__m">' + esc(mark) + '</i>' : '') + '</span>'
    + (notes ? '<span class="hf-have__n">' + esc(perkNote(e)) + '</span>' : '') + '</li>';
}
/* o.notes: the sentence under each line. o.marks: say what is new at this level.
   o.none: the line an empty group gets; no line means the group is left out. */
function kindHtml(kind, items, o) {
  var K = C.kinds || {};
  if (!items.length && !o.none) return '';
  return '<div class="hf-kind" data-kind="' + kind + '"><' + (o.tag || 'p') + ' class="hf-kind__h">' + esc(K[kind] || kind) + ' <span>' + esc(K[kind + '_x'] || '') + '</span></' + (o.tag || 'p') + '>'
    + (items.length ? '<ul>' + items.map(function (e) { return haveHtml(o.marks ? e : Object.assign({}, e, { _mark: '' }), o.notes); }).join('') + '</ul>' : '<p class="hf-kind__none">' + esc(o.none) + '</p>') + '</div>';
}
/* What an empty group says for a level: the next level that fills it, and how far off it is. */
/* the first level whose list of this kind is not empty (-1 if none) */
function firstWith(kind) { for (var k = 0; k < LEVELS.length; k++) if (haveAt(k)[kind].length) return k; return -1; }
function noneFor(kind, i) {
  var K = C.kinds || {};
  for (var k = i + 1; k < LEVELS.length; k++) {
    var got = haveAt(k)[kind];
    if (got.length) return fill(kind === 'rewards' ? K.none_rewards : K.none_perks, { label: LEVELS[k].label, money: money(LEVELS[k].min_pct) });
  }
  return '';
}

/* ── THE CARD ───────────────────────────────────────────────────────────────
   i is a level index, 'guest' or 'secret'. o.mine prints a person's number and
   name; otherwise the card carries the level's own name and gate. */
/* ── THE FIGURE. A benefit is drawn before it is described: money when it is money, its own
   number when it has one ("48h", "5%"), otherwise a glyph. One 24-unit grid, one stroke. */
var GLYPH = {
  inbox: 'M3 6.5h18v11H3z M3.5 7l8.5 6.5L20.5 7',
  restock: 'M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2h-15z M10 20.5a2 2 0 0 0 4 0',
  nights: 'M5 20.5V9l7-5.5L19 9v11.5 M9.5 20.5v-5a2.5 2.5 0 0 1 5 0v5 M3 20.5h18',
  rail: 'M12 8.5V7.2a2 2 0 1 0-2-2 M12 8.5l9 6.2c.9.6.5 2-.6 2H3.6c-1.1 0-1.5-1.4-.6-2z',
  vote: 'M4 4h16v16H4z M8 12.2l3 3 5.2-6.2',
  presents: 'M3 8a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2.2a1.8 1.8 0 0 0 0 3.6V16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2.2a1.8 1.8 0 0 0 0-3.6z M14.5 7v2 M14.5 11v2 M14.5 15v2',
  support: 'M4 5h16v11H11l-4.5 3.5V16H4z',
  exchanges: 'M4 9h14 M14.5 5.5L18 9l-3.5 3.5 M20 15H6 M9.5 11.5L6 15l3.5 3.5',
  card: 'M3 6h18v12H3z M3 10h18 M6.5 14.5h4',
  early: 'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17z M12 7.5V12l3 2',
  shipping: 'M3.5 8L12 3.5 20.5 8v8.5L12 21l-8.5-4.5z M3.5 8L12 12.5 20.5 8 M12 12.5V21',
  unreleased: 'M8 4L3 7l2 3.5 2-1V20h10V9.5l2 1L21 7l-5-3a3 3 0 0 1-6 0z',
  'early:held': 'M3.5 12.5V4.5h8l9 9-8 8z M8.2 9.2h.01',
  drop: 'M12 3.5c3.2 4 5.5 6.9 5.5 10a5.5 5.5 0 0 1-11 0c0-3.1 2.3-6 5.5-10z'
};
function figure(e) {
  var a = e._k === 'back' ? '' : perkAmt(e), v = rateOf(e);
  if (a || v) return '<b class="hf-fig" data-fig="n">' + esc(a || v) + '</b>';
  return '<b class="hf-fig" data-fig="g"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + (GLYPH[e._k + ':' + e.v] || GLYPH[e._k] || GLYPH.drop) + '"/></svg></b>';
}

/* ── THE TALLY. One scratch per level u have climbed: house trained is unmarked, FERAL has
   four, and the strike that finishes the five belongs to the level nobody has seen. The
   strokes lean a little, by hand. `fresh` draws the newest one in. */
var LEAN = [[1.2, -.6], [.4, .3], [1.6, -.2], [.2, -1]];
function tally(n) {
  var s = '', k, x, m = Math.min(n, 4);
  /* set from the right, so one scratch sits where four end */
  for (k = 0; k < m; k++) { x = 35 - (m - 1 - k) * 10; s += '<path pathLength="1"' + (k === n - 1 ? ' class="is-last"' : '') + ' d="M' + (x + LEAN[k][0]) + ' 3L' + (x + LEAN[k][1]) + ' 33"/>'; }
  if (n > 4) s += '<path pathLength="1" class="is-strike is-last" d="M-2 27L42 9"/>';
  return '<svg viewBox="-4 0 48 36" aria-hidden="true" focusable="false">' + s + '</svg>';
}
function tallyOf(i) { return i === 'secret' ? 5 : i === 'guest' ? 0 : +i || 0; }

function cardArt(i) {
  if (i === 'secret') return '';
  if (i === 'guest' || +i === 2) return X.art_feral || '';
  return X['art_' + (LEVELS[i] || {}).key] || '';
}

function card(i, o) {
  o = o || {};
  var l = LEVELS[i] || {}, secret = i === 'secret', guest = i === 'guest';
  var art = cardArt(i), css = [];
  if (art) css.push("--hf-art:url('" + art + "')");
  if (X.wordmark) css.push("--hf-mark:url('" + X.wordmark + "')");
  var h = '<div class="hf-card' + (o.bare ? ' is-mini' : '') + (art ? ' has-art' : '') + (o.fresh ? ' is-new' : '') + '" data-level="' + i + '"' + (css.length ? ' style="' + esc(css.join(';')) + '"' : '') + '>'
    + '<i class="hf-card__mat" aria-hidden="true"><i class="hf-card__art"></i><i class="hf-card__imprint"></i><i class="hf-card__cuts"><i class="hf-card__foil"></i></i><i class="hf-card__grain"></i><i class="hf-card__sheen"></i></i>';
  if (o.bare) return h + (X.wordmark ? '<b class="hf-card__mini-mark" aria-hidden="true"></b>' : '') + '</div>';
  /* with the real wordmark the mark is a picture, so it carries a label and no text to measure */
  h += X.wordmark ? '<b class="hf-card__mark is-img" role="img" aria-label="FERAL"></b>' : '<b class="hf-card__mark">FERAL</b>';
  h += '<b class="hf-card__edition" aria-hidden="true"><i data-hf-c="edition">' + (secret ? '??' : guest ? '' : pad(+i + 1) + ' / 05') + '</i></b>';
  h += '<i class="hf-card__tally' + (o.cut && !CALM ? ' is-cut' : '') + '" data-hf-c="tally" data-n="' + tallyOf(i) + '">' + tally(tallyOf(i)) + '</i>';
  if (o.mine) {
    h += '<b class="hf-card__lvl" data-hf-c="lvl">' + esc(guest ? '' : l.label) + '</b>';
    h += '<b class="hf-card__n" data-hf-c="n">' + (guest ? '??' : o.pct != null ? o.pct : 0) + '<i>%</i></b>';
    if (guest && (C.guest || {}).card) h += '<div class="hf-card__who"><b>' + esc(C.guest.card) + '</b>' + (C.guest.card_x ? '<i>' + esc(C.guest.card_x) + '</i>' : '') + '</div>';
    else if (o.name || o.since) h += '<div class="hf-card__who">' + (o.name ? '<b title="' + esc(o.name) + '">' + esc(o.name) + '</b>' : '') + (o.since ? '<i>' + esc(fill(C.since, { y: o.since })) + '</i>' : '') + '</div>';
  } else {
    var label = secret ? SECRET.label : l.label || '';
    var K = C.card || {}, from = secret ? fill(K.from, { money: cash(SECRET.min_pct) }) : !l.requires_order ? K.none : l.min_pct > 0 ? fill(K.from, { money: cash(l.min_pct) }) : K.first;
    var life = secret ? '' : l.requires_order ? K.life : K.now;
    h += '<b class="hf-card__name' + (label.length > 9 ? ' is-long' : '') + '">' + esc(label) + '</b>';
    if (from) h += '<div class="hf-card__who hf-card__who--gate"><b>' + esc(from) + '</b>' + (life ? '<i>' + esc(life) + '</i>' : '') + '</div>';
  }
  return h + '</div>';
}
/* A level's card, as the person looking at it: their own level carries their number. */
function cardFor(i, fresh) {
  if (i === 'secret') return card('secret', { fresh: fresh });
  return !state.guest && i === state.level ? card(i, { mine: true, name: state.name, since: state.since, pct: state.pct, fresh: fresh }) : card(i, { fresh: fresh });
}

/* ── HERO ───────────────────────────────────────────────────────────────── */
function nextNode() {
  if (state.guest) return null;
  if (state.orders < 1) return { first: true };
  var gate = null;
  LEVELS.forEach(function (l, i) { if (!gate && i > state.level && l.requires_order && l.min_pct > state.pct) gate = l; });
  var drop = (Math.max(state.drop_cursor || 0, Math.floor(state.pct / EVERY)) + 1) * EVERY;
  return gate && gate.min_pct <= drop ? { at: gate.min_pct, label: gate.label } : { at: drop };
}
/* The next thing, in money: "€38 to FRONT ROW." or "spend €12 more for ur next €6 credit."
   The credit is the one the member's level actually pays, never the base unit. */
function nextCredit() {
  var cursor = Math.max(state.drop_cursor || 0, Math.floor(state.pct / EVERY));
  return X.sym && DROP_N ? X.sym + DROP_N * Rewards.backAt(S, cursor + 1, state.level, state.orders) : '';
}
function nextWords(nx) {
  if (!nx) return { main: '', about: '' };
  if (nx.first) return { main: fill((C.next || {}).first, WORDS), about: '' };
  var m = spendTo(nx.at), d = nextCredit();
  if (nx.label) return { main: fill(C.next.level, { money: m, label: nx.label }), about: '' };
  return { main: d ? fill(C.next.drop, { money: m, drop: d }) : fill((C.personal || {}).drop_note, { money: m }), about: '' };
}

function countTo(node, to, from) {
  if (!node) return;
  node._hfTarget = to;
  var set = function (v) { node.firstChild.nodeValue = String(v); };
  from = from || 0;
  if (calmCards() || !window.requestAnimationFrame || from === to) { node._hf = (node._hf || 0) + 1; return set(to); }
  var t0 = null, ms = 900;
  node._hf = (node._hf || 0) + 1; var mine = node._hf;
  requestAnimationFrame(function step(t) {
    if (mine !== node._hf) return;
    if (t0 == null) t0 = t;
    var k = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - k, 3);
    set(Math.round(from + (to - from) * e));
    if (k < 1 && node.isConnected) requestAnimationFrame(step);
  });
}

/* The public opening exhibits the five published cards, without claiming that
   any is the visitor's. The member opening keeps their own earned card. */
function drawPeeks() {
  var box = el('peeks');
  if (!state.guest || state.pending) { box.innerHTML=''; box.hidden=true; return; }
  box.hidden=false;
  if(box.querySelector('.hf-fan'))return;
  var positions=[-2,-1,2,1,0];
  box.innerHTML='<button type="button" class="hf-fan'+(calmCards()?' is-calm':'')+'" data-peek="2" aria-label="Explore the five membership cards">'+LEVELS.map(function(l,i){return '<span class="hf-peek" style="--slot:'+positions[i]+';--depth:'+Math.abs(positions[i])+'" aria-hidden="true">'+card(i)+'</span>';}).join('')+'</button>';
}

function heroCard() { return document.querySelector('[data-hf="mycard"] .hf-card'); }
function heroN() { return document.querySelector('[data-hf="mycard"] [data-hf-c="n"]'); }

function drawCard(from) {
  clearInterval(scramble);
  var g = !!state.guest, l = LEVELS[state.level] || {}, box = el('mycard');
  box.innerHTML = card(g ? 'guest' : state.level, { mine: true, name: state.name, since: state.since });
  el('cardbox').setAttribute('data-room', g ? '' : state.level);
  drawPeeks(g ? -1 : state.level);
  box.setAttribute('role', 'img');
  box.setAttribute('aria-label', state.pending ? C.personal.sync : g ? 'ur card. log in to see ur score.' : state.pct + '% feral. ' + (l.label || '').toLowerCase() + '.');
  var n = heroN();
  if (!g) countTo(n, state.pct, from == null ? state.pct : from);
  // A guest has no score. Never animate a random number that looks like theirs.
  sweep();
  cardStatus(); refreshCardMotion();
}

function cardStatus() {
  var node = el('card-state'); if (!node) return;
  var K = C.card || {};
  node.textContent = tried ? fill(K.forecast, {from: state.guest ? 0 : state.pct, to: project(tried).to}) : state.pending ? K.syncing : state.guest ? K.waiting : state.level === 0 ? K.starter : K.yours;
  node.classList.toggle('is-preview', !!tried);
  document.querySelector('.hf-hero').classList.toggle('is-forecast', !!tried);
  var exhibit=state.guest&&!state.pending&&!tried;
  el('mycard').hidden=exhibit; el('peeks').hidden=!exhibit;
  el('card-state').textContent=exhibit?'five cards. which one’s urs?':node.textContent;
}

function drawMeter() {
  var g = !!state.guest, gates = LEVELS.filter(function (x) { return x.requires_order; });
  /* a guest sees the scale, and no dot on it until they try. A class, not [hidden]: the dot is an
     empty data-lp-keep element, and the kit's keep rule is display:block !important. */
  el('meter').hidden = !g || !tried; el('meter').classList.toggle('is-blank', g && !tried);
  el('gates').innerHTML = gates.map(function (x, i) {
    return '<li class="' + (i === 0 ? 'is-first ' : '') + (i === gates.length - 1 ? 'is-last ' : '') + (!g && state.orders >= 1 && state.pct >= x.min_pct ? 'is-on' : '') + '" style="left:' + x.min_pct + '%">' + esc(x.label) + '</li>';
  }).join('');
  var pips = ''; for (var p = EVERY; p < 100; p += EVERY) pips += '<i style="left:' + p + '%"></i>';
  el('pips').innerHTML = pips;
  var w = g ? 0 : Math.max(0, Math.min(100, state.pct));
  /* painted a frame later, so the fill and the dot travel instead of jumping */
  setTimeout(function () { el('fill').style.width = w + '%'; el('u').style.left = w + '%'; }, 30);
  el('meter-aria').setAttribute('aria-label', g ? gates.map(function (x) { return x.label.toLowerCase(); }).join(', ') : state.pct + '% feral');
}

function paintHero() {
  tried = 0;
  var g = !!state.guest, l = LEVELS[state.level] || {}, P = C.personal || {};
  var hero = document.querySelector('.hf-hero');
  hero.classList.toggle('is-guest', g); hero.classList.toggle('is-member', !g); hero.classList.toggle('is-pending', !!state.pending);
  var q = el('q');
  if (!g || state.pending) q.textContent = state.pending ? P.pending_heading : P.heading;
  else q.innerHTML = (C.question || '').split('\n').map(function (t, i) { return '<span class="hf-q__l" style="--i:' + i + '">' + esc(t) + '</span>'; }).join('<br>');
  el('identity').textContent = state.pending ? P.pending_identity : g ? 'FERAL CLOTHING / MEMBERSHIP' : (state.name ? fill(P.greeting, {name: state.name}) : P.identity) + (state.since ? ' / ' + fill(C.since, {y: state.since}) : '');
  el('account').hidden = g && !state.pending;
  if(PREVIEW){
    var accountURL=new URL(el('account').href);
    accountURL.pathname=accountURL.pathname.replace(/\/pages\/your-feral$/, '/pages/contact');
    accountURL.searchParams.set('view','your-feral');accountURL.searchParams.set('preview_theme_id','195447554430');
    if(state.preview)accountURL.searchParams.set('fa_preview',state.pending?'pending':state.orders<1?'empty':'member');else accountURL.searchParams.delete('fa_preview');
    el('account').href=accountURL.href;
  }
  /* On a phone a guest's card asks the question, so the button that answers it goes right
     under the card; a member reads their number first and the button last. Moved, not
     re-ordered in CSS, so a keyboard and a screen reader meet them in the order the eye does. */
  var say = el('say'), go = el('go'), al0 = el('already');
  if (g && !mq('(min-width: 990px)')) { say.insertBefore(go, say.firstChild); say.insertBefore(al0, go.nextSibling); } else { say.appendChild(go); say.appendChild(al0); }
  say.classList.toggle('is-guest', g);
  drawCard();
  el('lede').textContent = state.pending ? C.personal.sync : g ? (C.guest || {}).lede : (state.pct > 100 ? C.off_scale : (C.lede || {})[l.key]) || '';
  var top = el('top'); top.hidden = true; // Historic population percentiles are not live facts.
  if (!top.hidden) top.textContent = fill(C.top, { n: l.top_pct });
  drawMeter();

  var nx = g ? null : state.orders<1 ? {first:true} : {at:(Math.max(state.drop_cursor||0,Math.floor(state.pct/EVERY))+1)*EVERY}, next = el('next'), w = nextWords(nx); next.hidden = !nx;
  if (nx) next.innerHTML = esc(w.main) + (w.about ? ' <em>' + esc(w.about) + '</em>' : '');

  /* real money already sitting on the account: Shopify's own figure, or a demo one */
  var wal = el('wallet'), m = g && !state.pending ? '' : typeof state.credit === 'number' ? gift(state.credit) : state.credit || '';
  wal.hidden = !m;
  if (m) wal.innerHTML = '<span class="hf-wallet__label">' + esc(P.credit) + '</span><b>' + esc(m) + '</b><span class="hf-wallet__note">' + esc(C.wallet || '') + '</span>';

  el('login').hidden = !g || !!state.pending; el('login').textContent = (C.guest || {}).cta || 'join free';
  el('shop').hidden = g && !state.pending; el('shop').textContent = C.shop || 'shop';
  el('jump').textContent = C.jump; el('jump').hidden = !g || !!state.pending;
  if (!g) say.insertBefore(next, el('personal'));
  var al = el('already'); al.hidden = !g || !!state.pending; al.textContent = (C.guest || {}).already || '';
  paintPersonal();
  paintMemberPerks();
  setMemberView('perks');
  el('simulator').open=false;
  paintTry();
  paintDock();
}

/* ── TRY IT. The scheme, played: tap an order, the card shows what it does.
   Nothing is saved and nothing is promised that the rules do not do. */
var TRY = [10, 20, 40];
function projectionState() {
  if (state.guest) return {net_minor: 0, orders: 0, level: 0, drop_cursor: 0};
  return {net_minor: state.net_minor != null ? state.net_minor : state.pct * PER * 100, orders: state.orders, level: state.level, drop_cursor: state.drop_cursor || 0};
}
function project(add) {
  var p = Rewards.project(S, projectionState(), Math.round(add * PER * 100));
  var regular = (p.regular_x == null ? p.regular : p.regular_x) * DROP_N, bonus = p.levelups.reduce(function (n, u) { return n + Math.round(u.gbp * FX); }, 0);
  var gate = LEVELS[p.after.level + 1];
  return {after: p.after, from: p.before.pct, to: p.after.pct, was: p.before.level, level: p.after.level, drops: p.regular + p.levelups.length, back: regular + bonus, regular: regular, bonus: bonus, regular_count: p.regular, bonus_count: p.levelups.length, gate: gate};
}
function paintPersonal() {
  var box = el('personal'), g = !!state.guest, P = C.personal || {};
  box.hidden = g;
  if (g) return;
  var cursor = Math.max(state.drop_cursor || 0, Math.floor(state.pct / EVERY));
  var start = cursor * EVERY, progress = Math.max(0, Math.min(100, (state.pct - start) / EVERY * 100));
  var protectedLevel = state.level > levelFrom(state.pct, state.orders), nx = LEVELS[state.level + 1];
  var levelStart = LEVELS[state.level].min_pct, levelProgress = nx ? Math.max(0, Math.min(100, (state.pct - levelStart) / Math.max(1, nx.min_pct - levelStart) * 100)) : 100;
  function track(value, label) { return '<div class="hf-personal__track" role="meter" aria-label="' + esc(label) + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + value + '"><i style="width:' + value + '%"></i></div>'; }
  /* The next level is never folded away: how close it is, and what it adds, grouped the way
     the rest of the page groups them. At the top there is nothing to add, so it says so. */
  var go = nx ? Math.max(0, nx.min_pct - state.pct) : 0, K = C.kinds || {}, adds = nx ? addsAt(state.level + 1) : null;
  var far = nx ? (state.orders ? fill(P.remaining, { money: spendTo(nx.min_pct) }) : C.levels.locked_first) : C.off_scale;
  /* Once there is an order, the hero line directly above already says "spend X more for ur
     next Y credit", so the bar needs no caption. Before one, that line is about the first
     order, and the caption says what the bar is for. */
  var credit = nextCredit();
  box.innerHTML = '<div class="hf-personal__drop">' + track(progress, 'Progress to next credit') + (state.orders < 1 ? '<em>' + esc((credit ? credit + ' · ' : '') + (P.next_drop || '')) + '</em>' : '') + '</div>'
    + '<section class="hf-personal__level" aria-labelledby="hf-next-level"><p class="hf-personal__k" id="hf-next-level">' + esc(nx ? P.next_level : P.saved) + '</p>'
    + '<p class="hf-personal__h"><b>' + esc(nx ? nx.label : LEVELS[state.level].label) + '</b> <span>' + esc(far) + '</span></p>'
    + track(levelProgress, nx ? 'Progress to next level' : 'Highest published level earned')
    + (adds ? '<p class="hf-personal__k">' + esc(fill(K.adds, { label: nx.label })) + '</p><div class="hf-kinds is-compact">' + kindHtml('rewards', adds.rewards, { marks: true }) + kindHtml('perks', adds.perks, { marks: true }) + '</div>' : '')
    + '</section>'
    + (protectedLevel ? '<p class="hf-personal__protected">' + esc(fill(P.protected,{label:LEVELS[state.level].label})) + '</p>' : '');
}

/* The member's benefits use the same effective rows as the comparison. Upgrades
   replace old values; the overview never invents delivery or transaction history. */
function paintMemberPerks() {
  var box = el('memberperks'), P = C.personal || {};
  box.hidden = !!state.guest;
  if (state.guest) { box.innerHTML = ''; return; }
  var K = C.kinds || {}, have = haveAt(state.level);
  /* rewards on one side, perks on the other; each line opens to its sentence */
  var group = function (kind) {
    var none = noneFor(kind, state.level);
    return '<div class="hf-kind" data-kind="' + kind + '"><h3 class="hf-kind__h">' + esc(K['ur_' + kind] || kind) + ' <span>' + esc(K[kind + '_x'] || '') + '</span></h3>'
      + (have[kind].length ? have[kind].map(function(e){return '<details class="hf-owned"><summary><span>'+esc(shortTitle(e))+'</span>'+figure(e)+'<i aria-hidden="true">+</i></summary><p>'+esc(perkNote(e))+'</p></details>';}).join('') : '<p class="hf-kind__none">' + esc(none) + '</p>') + '</div>';
  };
  box.innerHTML='<h2 class="lp-sr" id="hf-memberperks-h">'+esc(K.tab||'')+'</h2><p class="hf-memberperks__intro">'+esc(fill(K.at,{label:LEVELS[state.level].label}))+'</p><p class="hf-memberperks__key">'+esc(K.key||'')+'</p><div class="hf-memberperks__grid">'+group('rewards')+group('perks')+'</div><div class="hf-invitations" data-hf="invitations"></div>';
  paintInvitations();
}

/* Invitations are merchandising announcements, not a secret checkout gate.
   Never allow a remote calendar to inject markup or an arbitrary destination. */
function paintInvitations() {
  var box=el('invitations'); if(!box||state.guest)return;
  var A=C.access||{},calendar=[];
  try{calendar=JSON.parse(X.invitations||'[]');}catch(_){}
  var rows=Access ? Access.forMember(calendar,state.level,Date.now(),S) : [];
  var demo=PREVIEW&&state.preview&&new URLSearchParams(location.search).get('hf_invites');
  if(demo&&Access){var now=Date.now();var night=demo==='night';rows=Access.forMember([{key:'demo-release',title:night?'a FERAL event · demo invitation':'a FERAL drop · demo invitation',kind:night?'night':'drop',general_at:new Date(now+(demo==='upcoming'?80:12)*3600000).toISOString(),ends_at:new Date(now+120*3600000).toISOString(),url:night?'/pages/how-feral':'/collections/all',state:'published'}],state.level,now,S);}
  var opens=firstWith('perks');
  var markup='<h3>'+esc(A.h)+'</h3>'+(!rows.length?'<p>'+esc(opens>=0&&state.level<opens?fill(A.locked,{label:LEVELS[opens].label}):A.empty)+'</p><p class="hf-invitations__note">'+esc(A.note)+'</p>':rows.map(function(r){var when=new Intl.DateTimeFormat(undefined,{dateStyle:'medium',timeStyle:'short'}).format(new Date(r.opens_at));return '<article data-hf-release="'+esc(r.key)+'"><div><p class="hf-eyebrow">'+esc((A.kind||{})[r.kind]||'')+'</p><h4>'+esc(r.title)+'</h4><p>'+esc(r.status==='open'?'ur invitation is open.':A.starts+' '+when+' · ur local time')+'</p></div>'+(r.status==='open'?'<a class="lp-cta lp-cta--ghost" href="'+esc(r.url)+'">'+esc(r.kind==='night'?A.cta_night:A.cta)+'</a>':'')+'</article>';}).join(''));
  if(box._markup!==markup){box.innerHTML=markup;box._markup=markup;}
}
setInterval(function(){if(!document.hidden)paintInvitations();},60000);

var memberView='perks';
function setMemberView(key) {
  var member=!state.guest, pending=!!state.pending, keys=['perks','collection','details'];
  memberView=keys.indexOf(key)>=0?key:'perks';
  if(memberView!=='collection'&&tried){tried=0;drawCard();drawMeter();paintTry();el('simulator').open=false;}
  document.body.classList.toggle('hf-member-page',member||pending);
  el('member-nav').hidden=!member;
  all('[data-member-view]').forEach(function(b){var on=b.getAttribute('data-member-view')===memberView;b.setAttribute('aria-selected',String(on));b.tabIndex=on?0:-1;});
  all('[data-member-pane]').forEach(function(p){var name=p.getAttribute('data-member-pane');p.hidden=member ? name!==memberView : pending || name==='perks';if(member){p.setAttribute('role','tabpanel');p.setAttribute('aria-labelledby','hf-member-tab-'+name);p.tabIndex=0;}else{p.removeAttribute('role');p.removeAttribute('aria-labelledby');p.removeAttribute('tabindex');}});
  refreshCardMotion();
}
el('member-nav').addEventListener('click',function(e){var b=e.target.closest('[data-member-view]');if(b)setMemberView(b.getAttribute('data-member-view'));});
el('member-nav').addEventListener('keydown',function(e){var bs=all('[data-member-view]'),at=bs.indexOf(document.activeElement),next=at;if(at<0)return;if(e.key==='ArrowRight')next=(at+1)%bs.length;else if(e.key==='ArrowLeft')next=(at+bs.length-1)%bs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=bs.length-1;else return;e.preventDefault();setMemberView(bs[next].getAttribute('data-member-view'));bs[next].focus();});

function buildTry() {
  el('simulator').addEventListener('toggle',function(){if(!this.open&&tried){tried=0;drawCard();drawMeter();paintTry();}});
  var T = C['try'] || {};
  el('try-label').textContent = T.spend;
  el('try-fine').textContent = fill(T.disclaimer, WORDS);
  document.getElementById('hf-order-range').addEventListener('input', function (ev) { tried = +ev.target.value; if (tried) playTry(); else { drawCard(); drawMeter(); paintTry(); } });
  el('try-chips').innerHTML = TRY.map(function (n) { return '<button type="button" data-add="' + n + '" aria-pressed="false">+' + esc(cash(n)) + '</button>'; }).join('')
    + '<button type="button" class="hf-try__reset" data-add="0" hidden>' + esc(T.reset || 'reset') + '</button>';
  el('try-chips').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    var add = +b.getAttribute('data-add');
    if (!add || add === tried) { var back = tried ? project(tried).to : 0; tried = 0; drawCard(back); drawMeter(); paintTry(); if (!add) { var f = el('try-chips').querySelector('button'); if (f) f.focus(); } return; }
    tried = add; playTry();
  });
}
function paintTry() {
  var T = C['try'] || {}, q = state.guest ? T.q_guest : T.q;
  el('try-q').textContent = q || ''; el('try-chips').setAttribute('aria-label', q || '');
  all('[data-hf="try-chips"] button').forEach(function (b) {
    var add = +b.getAttribute('data-add');
    if (add) b.setAttribute('aria-pressed', add === tried ? 'true' : 'false'); else b.hidden = !tried;
  });
  document.getElementById('hf-order-range').value = tried;
  document.getElementById('hf-order-range').setAttribute('aria-valuetext', cash(tried));
  el('try-amount').textContent = cash(tried);
  el('receipt').hidden = !tried;
  if (!tried) { el('try-out').innerHTML = '<em>' + esc(T.idle || '') + '</em>'; el('ghost').style.width = '0%'; }
}
function playTry() {
  var T = C['try'] || {}, p = project(tried), c = heroCard(), l = LEVELS[p.level] || {};
  clearInterval(scramble);
  /* the card becomes the card u would hold */
  if (c) {
    var art = cardArt(p.level);
    c.setAttribute('data-level', p.level); c.classList.toggle('has-art', !!art);
    if (art) c.style.setProperty('--hf-art', "url('" + art + "')"); else c.style.removeProperty('--hf-art');
    var lv = c.querySelector('[data-hf-c="lvl"]'); if (lv) lv.textContent = l.label || '';
    var edition = c.querySelector('[data-hf-c="edition"]'); if (edition) edition.textContent = pad(p.level + 1) + ' / 05';
    var tl = c.querySelector('[data-hf-c="tally"]');
    if (tl && tl.getAttribute('data-n') !== String(tallyOf(p.level))) { tl.classList.toggle('is-cut', !CALM && tallyOf(p.level) > +tl.getAttribute('data-n')); tl.setAttribute('data-n', tallyOf(p.level)); tl.innerHTML = tally(tallyOf(p.level)); }
    var n = heroN(), shown = parseInt(n.firstChild.nodeValue, 10); countTo(n, p.to, state.guest || isNaN(shown) ? 0 : shown);
    el('cardbox').setAttribute('data-room', p.level); drawPeeks(p.level);
    if (!CALM) { c.classList.remove('is-pop'); void c.offsetWidth; c.classList.add('is-pop'); }
    sweep();
  }
  drawMeter();
  var a = Math.min(100, p.from), b = Math.min(100, p.to);
  el('ghost').style.left = a + '%'; el('ghost').style.width = Math.max(0, b - a) + '%';
  var say = [fill(T.to, { pct: p.to })], worth = p.back && X.sym ? fill(T.worth, { money: X.sym + p.back }) : '';
  if (p.level > p.was) say.push(fill(T.level, { label: l.label }));
  if (p.drops) say.push(p.drops === 1 ? T.drop1 : fill(T.dropn, { n: p.drops }));
  /* still short of the next level: say by how much, because that is the useful part */
  var tail = [worth, p.level === p.was && p.gate ? fill(T['short'], { money: spendTo(p.gate.min_pct, p.after), label: p.gate.label }) : ''].filter(Boolean).join(' ');
  el('try-out').innerHTML = esc(say.join(' ')) + (tail ? ' <em>' + esc(tail) + '</em>' : '');
  el('mycard').setAttribute('aria-label', 'Order preview: ' + p.to + '% feral. ' + l.label.toLowerCase() + '. Your real score is unchanged.');
  var receipt = el('receipt');
  receipt.innerHTML = [['regular',p.regular,p.regular_count],['bonus',p.bonus,p.bonus_count],['total',p.back,p.drops]].filter(function (r) { return r[0] !== 'bonus' || r[2]; }).map(function (r) { return '<div><dt>' + esc(T[r[0]]) + '</dt><dd>' + esc(X.sym ? X.sym + r[1] : String(r[2])) + '</dd></div>'; }).join('');
  paintTry();
  cardStatus(); refreshCardMotion();
}

/* ── THE CARD MOVES. A pointer tilts it on a desktop; on a phone the scroll does,
   so the light crosses each card as it passes. Reduced motion: neither. */
function sweep() {
  var c = heroCard(); if (!c || calmCards() || !FINE) return;
  c.style.setProperty('--hf-sx', '-34%');
  setTimeout(function () { if (!calmCards()) c.style.setProperty('--hf-sx', '34%'); }, 350);
}
function pointerTilt(box) {
  if (!box || !FINE) return;
  box.addEventListener('pointermove', function (e) {
    if (calmCards()) return;
    var c = box.querySelector('.hf-card'); if (!c) return;
    var r = box.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
    c.classList.add('is-live');
    c.style.setProperty('--hf-ry', (x * 14).toFixed(2) + 'deg'); c.style.setProperty('--hf-rx', (-y * 10).toFixed(2) + 'deg');
    c.style.setProperty('--hf-sx', (x * 60).toFixed(1) + '%');
  });
  box.addEventListener('pointerleave', function () {
    var c = box.querySelector('.hf-card'); if (!c) return;
    c.classList.remove('is-live'); c.style.setProperty('--hf-ry', '0deg'); c.style.setProperty('--hf-rx', '0deg');
  });
}
function scrollTilt() {
  if (FINE || !('IntersectionObserver' in window) || !window.requestAnimationFrame) return;
  var live = [], tick = 0;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { var k = live.indexOf(e.target); if (e.isIntersecting && k < 0) live.push(e.target); if (!e.isIntersecting && k >= 0) live.splice(k, 1); });
    run();
  });
  [el('mycard')].concat(all('.hf-ch__card')).forEach(function (b) { if (b) io.observe(b); });
  function run() {
    tick = 0; if (calmCards()) return; var H = window.innerHeight || 1;
    live.forEach(function (b) {
      var c = b.querySelector('.hf-card'); if (!c) return;
      var r = b.getBoundingClientRect(), p = Math.max(-1, Math.min(1, ((r.top + r.height / 2) / H - .5) * 2));
      c.classList.add('is-live');
      c.style.setProperty('--hf-rx', (p * 7).toFixed(2) + 'deg'); c.style.setProperty('--hf-ry', (p * -3).toFixed(2) + 'deg');
      c.style.setProperty('--hf-sx', (p * -52).toFixed(1) + '%');
    });
  }
  window.addEventListener('scroll', function () { if (!tick) tick = requestAnimationFrame(run); }, { passive: true });
}

/* Moving material, not moving text. Only full-size, visible cards animate.
   All miniature/hidden cards stay still. User and OS preferences apply live. */
function refreshCardMotion() {
  if (!motionObserver || motionFrame) return;
  motionFrame = requestAnimationFrame(function () {
    motionFrame = 0; motionObserver.disconnect();
    all('.hf-card:not(.is-mini)').forEach(function (c) { c.classList.remove('is-visible'); motionObserver.observe(c); });
  });
}
function applyMotionPreference() {
  var paused = calmCards(), K = C.card || {};
  all('.hf-fan').forEach(function(f){f.classList.toggle('is-calm',paused);});
  document.body.classList.toggle('hf-motion-paused', paused);
  document.body.classList.toggle('hf-page-hidden', document.hidden);
  all('[data-hf-motion]').forEach(function (b) {
    b.textContent = CALM ? K.motion_off : motionPaused ? K.motion_play : K.motion_pause;
    b.setAttribute('aria-pressed', String(paused)); b.disabled = CALM;
    b.title = CALM ? K.motion_system : '';
  });
  if (paused) all('.hf-card').forEach(function (c) {
    c.classList.remove('is-live'); ['--hf-rx', '--hf-ry', '--hf-sx'].forEach(function (p) { c.style.removeProperty(p); });
    var n = c.querySelector('[data-hf-c="n"]'); if (n && n._hfTarget != null) { n._hf = (n._hf || 0) + 1; n.firstChild.nodeValue = String(n._hfTarget); }
  });
}
function initCardMotion() {
  if ('IntersectionObserver' in window) motionObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('is-visible', e.isIntersecting && e.intersectionRatio >= .15); });
  }, {threshold: [0, .15]});
  all('[data-hf-motion]').forEach(function (b) { b.addEventListener('click', function () {
    motionPaused = !motionPaused;
    try { localStorage.setItem('hf:motion-paused', motionPaused ? '1' : '0'); } catch (_) {}
    applyMotionPreference();
  }); });
  var pref = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
  if (pref) { var change = function (e) { CALM = e.matches; applyMotionPreference(); }; if (pref.addEventListener) pref.addEventListener('change', change); else if (pref.addListener) pref.addListener(change); }
  document.addEventListener('visibilitychange', applyMotionPreference);
  applyMotionPreference(); refreshCardMotion();
}

/* ── THE CLIMB: one chapter per level, everything it gets, nothing behind a tap. Rewards and
   perks are listed whole, including what carries up from below, with what is new here marked. */
/* a chapter's three numbers: what it takes, what it pays back, how early. A level without
   the row simply has fewer numbers. */
function stat(dt, dd) { return dd ? '<div><dt>' + esc(dt || '') + '</dt><dd>' + esc(dd) + '</dd></div>' : ''; }
function rateAt(key, i) { var row = rowByKey(key), e = row && entry(row, i); return e ? rateOf(e) : ''; }
function buildClimb() {
  var K = C.levels || {}, n = LEVELS.length;
  el('levels-h').textContent = K.h || ''; el('levels-lede').textContent = K.lede || '';
  var h = LEVELS.map(function (l, i) {
    var have = haveAt(i), paid = l.requires_order && l.min_pct > 0, S = K.stat || {};
    return '<li class="hf-ch" data-ch="' + i + '">'
      + '<b class="hf-ch__u" aria-hidden="true"></b>'
      + '<div class="hf-ch__top"><span class="hf-ch__i">' + esc(fill(K.of, { i: pad(i + 1), n: pad(n) })) + '</span><span class="hf-state" data-hf-state="' + i + '" hidden></span></div>'
      + '<div class="hf-ch__card" data-hf-chcard="' + i + '" aria-hidden="true"></div>'
      + '<h3 class="hf-ch__h">' + esc(l.label) + '<i>.</i></h3>'
      + '<p class="hf-ch__say">' + esc(fill((K.say || {})[l.key], WORDS)) + '</p>'
      + '<dl class="hf-stats">'
      + stat(paid ? S.gate : !l.requires_order ? S.join : S.first, paid ? cash(l.min_pct) : !l.requires_order ? S.free : S.first_v)
      + stat(S.back, rateAt('back', i)) + stat(S.early, rateAt('early', i)) + '</dl>'
      + '<div class="hf-kinds">' + kindHtml('rewards', have.rewards, { tag: 'h4', notes: true, marks: i > 0, none: noneFor('rewards', i) })
      + kindHtml('perks', have.perks, { tag: 'h4', notes: true, marks: i > 0, none: noneFor('perks', i) }) + '</div></li>';
  }).join('');
  if (SECRET) {
    h += '<li class="hf-ch hf-ch--secret" data-ch="secret"><div class="hf-ch__top"><span class="hf-ch__i">' + esc(fill(K.of, { i: pad(n + 1), n: pad(n) })) + '</span></div>'
      + '<div class="hf-ch__card" data-hf-chcard="secret" aria-hidden="true">' + card('secret') + '</div>'
      + '<h3 class="hf-ch__h" data-hf-glitch="' + esc(SECRET.label) + '">' + esc(SECRET.label) + '</h3><p class="hf-ch__gate">' + esc(fill((C.secret || {}).gate, { n: SECRET.min_pct })) + '</p>'
      + '<p class="hf-ch__say">' + esc((C.secret || {}).p || '') + '</p></li>';
  }
  el('chapters').innerHTML = h;
  buildSelector();
}
function buildSelector() {
  var vertical = matchMedia('(min-width: 1100px)'), orient = function(){el('selector').setAttribute('aria-orientation',vertical.matches?'vertical':'horizontal');};
  orient(); if(vertical.addEventListener)vertical.addEventListener('change',orient);
  var CK = C.card || {};
  var choices = LEVELS.map(function(l,i){return {id:i,label:l.label,gate:l.requires_order ? l.min_pct ? cash(l.min_pct) : CK.first : CK.none};});
  if (SECRET) choices.push({id:'secret',label:SECRET.label,gate:cash(SECRET.min_pct)});
  el('selector').innerHTML = choices.map(function(l,n){return '<button type="button" role="tab" id="hf-tab-'+l.id+'" aria-controls="hf-panel-'+l.id+'" aria-selected="false" tabindex="-1" data-level-select="'+l.id+'"><span class="hf-selector__index" aria-hidden="true">'+pad(n+1)+'</span><b>'+esc(l.label)+'</b><em>'+esc(l.gate)+'</em><span class="hf-selector__status" data-selector-status="'+l.id+'"></span></button>';}).join('');
  all('.hf-ch').forEach(function(ch){var id=ch.getAttribute('data-ch');ch.id='hf-panel-'+id;ch.setAttribute('role','tabpanel');ch.setAttribute('aria-labelledby','hf-tab-'+id);ch.tabIndex=0;});
  el('selector').addEventListener('click',function(ev){var b=ev.target.closest('[data-level-select]');if(b) selectLevel(b.getAttribute('data-level-select'),false);});
  el('selector').addEventListener('keydown',function(ev){var bs=all('[data-level-select]'), at=bs.indexOf(document.activeElement); if(at<0)return;var next=at;if(ev.key==='ArrowRight'||ev.key==='ArrowDown')next=(at+1)%bs.length;else if(ev.key==='ArrowLeft'||ev.key==='ArrowUp')next=(at+bs.length-1)%bs.length;else if(ev.key==='Home')next=0;else if(ev.key==='End')next=bs.length-1;else return;ev.preventDefault();selectLevel(bs[next].getAttribute('data-level-select'),false);bs[next].focus();});
  all('[data-hf-step]').forEach(function(b){b.addEventListener('click',function(){var at=exploreAt==='secret'?LEVELS.length:exploreAt;var next=(at+(+b.getAttribute('data-hf-step'))+choices.length)%choices.length;selectLevel(choices[next].id,false);el('collection-live').textContent=choices[next].label+'. '+choices[next].gate+'.';});});
}
function selectLevel(id, jump) {
  var previous = exploreAt;
  exploreAt = id === 'secret' ? id : +id;
  all('.hf-ch').forEach(function(ch){ch.hidden=ch.getAttribute('data-ch')!==String(exploreAt);ch.classList.remove('is-wait');});
  all('[data-level-select]').forEach(function(b){var on=b.getAttribute('data-level-select')===String(exploreAt);b.setAttribute('aria-selected',String(on));b.tabIndex=on?0:-1;if(on && !mq('(min-width: 1100px)')){var nav=el('selector');nav.scrollLeft=Math.max(0,b.offsetLeft-nav.offsetLeft-(nav.clientWidth-b.clientWidth)/2);}});
  stageTo(exploreAt,true);
  if(previous!==exploreAt && !calmCards()){
    [el('stage').querySelector('.hf-card'),document.querySelector('[data-hf-chcard="'+exploreAt+'"] .hf-card')].forEach(function(c){if(c){c.classList.remove('is-new');void c.offsetWidth;c.classList.add('is-new');}});
  }
  el('stage-index').textContent = exploreAt==='secret' ? '??' : pad(exploreAt+1);
  document.querySelector('.hf-collection').setAttribute('data-selected',exploreAt);
  el('stage-caption').textContent = (C.card.finishes || {})[exploreAt] || '';
  el('collection-note').textContent = (C.card.finishes || {})[exploreAt] || '';
  if(jump) LP.jumpTo(document.querySelector('[data-hf-anchor="climb"]'));
}

var stageAt = 0;
function stageTo(i, quiet) {
  if (i === stageAt && !quiet) return;
  stageAt = i;
  var stage = el('stage'); if (!stage) return;
  stage.innerHTML = cardFor(i, !quiet && !CALM);
  refreshCardMotion();
}
/* How far through their own level somebody is: the rail beside the climb is the
   hero's meter stood on end, and the red dot on it is the same dot. */
function through() {
  if (state.guest || state.orders < 1) return 0;
  var from = (LEVELS[state.level] || {}).min_pct || 0, nx = LEVELS[state.level + 1], to = nx ? nx.min_pct : SECRET ? SECRET.min_pct : from + 100;
  return Math.max(0, Math.min(94, Math.round((state.pct - from) / Math.max(1, to - from) * 100)));
}
function paintClimb() {
  var K = C.levels || {};
  LEVELS.forEach(function (l, i) {
    var st = document.querySelector('[data-hf-state="' + i + '"]'), txt = '', cls = '';
    if (!state.guest) {
      if (i === state.level) { txt = K.here; cls = ' is-here'; }
      else if (i < state.level) { txt = K.done; cls = ' is-done'; }
      else txt = state.orders < 1 && l.min_pct <= 0 ? K.locked_first : fill(K.locked, { money: spendTo(l.min_pct) });
    }
    st.textContent = txt || ''; st.hidden = !txt; st.className = 'hf-state' + cls;
    var ch = document.querySelector('[data-ch="' + i + '"]');
    if (ch) {
      ch.classList.toggle('is-mine', !state.guest && i === state.level); ch.classList.toggle('is-done', !state.guest && i < state.level);
      ch.style.setProperty('--hf-prog', (!state.guest && i === state.level ? through() : 0) + '%');
    }
    var box = document.querySelector('[data-hf-chcard="' + i + '"]'); if (box) box.innerHTML = cardFor(i);
  });
  all('[data-selector-status]').forEach(function(b){var id=b.getAttribute('data-selector-status');b.textContent=!state.guest && +id===state.level ? K.here : '';});
  selectLevel(state.guest ? 2 : state.level, false);
}

/* ── SIDE BY SIDE: the same list as one table. House trained gets no column:
   it gets nothing, and a column of dashes teaches nothing. */
function cell(row, i) {
  var M = C.matrix || {}, e = entry(row, i);
  var dot = '<span class="hf-mx__dot" aria-hidden="true"></span><span class="lp-sr">' + esc(M.yes || 'yes') + '</span>';
  if (!e) return '<span class="hf-mx__no" aria-hidden="true">–</span><span class="lp-sr">' + esc(M.no || 'no') + '</span>';
  if (e.gbp) return gift(e.gbp) ? esc(gift(e.gbp)) : dot;
  return e.v === true || e.v == null ? dot : esc(fill(e.v, WORDS));
}
function buildMatrix() {
  var M = C.matrix || {}, cols = [];
  LEVELS.forEach(function (l, i) { if (l.requires_order) cols.push(i); });
  el('matrix-toggle').textContent = M.toggle || ''; el('matrix-h').textContent = M.h || ''; el('matrix-lede').textContent = M.lede || '';
  var h = '<table class="hf-mx__t"><caption class="lp-sr">' + esc(M.h || '') + '</caption><colgroup><col class="hf-mx__c0">' + cols.map(function () { return '<col>'; }).join('') + '</colgroup><thead><tr><td></td>'
    + cols.map(function (i) { return '<th scope="col" data-col="' + i + '" data-u="' + esc(M.u || 'u') + '"><span class="hf-mx__chip" aria-hidden="true">' + card(i, { bare: true }) + '</span>' + esc(LEVELS[i].label) + '</th>'; }).join('') + '</tr></thead><tbody>';
  /* rewards, then perks. The card is the membership itself, the same at every level, so a
     row of it would teach nothing. */
  BEN.groups.forEach(function (g) {
    var kind = KIND[g.key], rows = BEN.rows.filter(function (r) { return r.group === g.key && r.matrix !== false; }); if (!kind || !rows.length) return;
    h += '<tr class="hf-mx__g"><th scope="row">' + esc((C.kinds || {})[kind] || g.label) + '</th>' + cols.map(function (i) { return '<td data-col="' + i + '"></td>'; }).join('') + '</tr>';
    var per = (C.kinds || {}).per;
    rows.forEach(function (r) { h += '<tr><th scope="row">' + esc(r.key === 'back' && per ? r.label + ' ' + fill(per, WORDS) : r.label) + '</th>' + cols.map(function (i) { return '<td data-col="' + i + '">' + cell(r, i) + '</td>'; }).join('') + '</tr>'; });
  });
  el('matrix').innerHTML = h + '</tbody></table>';
}
function paintMatrix() {
  all('[data-hf="matrix"] [data-col]').forEach(function (c) { c.classList.toggle('is-u', !state.guest && +c.getAttribute('data-col') === state.level); });
}

/* ── THE REST: three beats, the side quests, the small print, the last word */
function buildRest() {
  var H = C.how || {}, Q = C.quests || {}, F = C.faq || {}, E = C.end || {};
  el('how-h').textContent = H.h || '';
  el('beats').innerHTML = ((LOCAL && X.drop ? H.beats : H.beats_plain) || []).map(function (b, i) { return '<li><div class="hf-plate" aria-hidden="true">' + plate(i) + '</div><b>' + esc(b.h) + '</b><em>' + esc(fill(b.p, WORDS)) + '</em></li>'; }).join('');
  el('quests-h').textContent = Q.h || ''; el('quests-lede').textContent = Q.lede || '';
  el('quests').innerHTML = (S.quests || []).map(function (q, i) {
    var m = X['quest_' + q.key];
    return '<li><span class="hf-quest__index" aria-hidden="true">' + pad(i+1) + '</span><span class="hf-quest__name">' + esc(q.label) + '</span><div>' + (m ? '<b>' + esc(m) + '</b>' : '') + '<em>' + esc(Q.soon || '') + '</em></div></li>';
  }).join('');
  document.querySelector('.hf-quests').hidden=!(S.quests||[]).length;
  document.querySelector('.hf-quests').nextElementSibling.hidden=!(S.quests||[]).length;
  el('faq-h').textContent = F.h || '';
  el('faq').innerHTML = (F.items || []).map(function (f) { return '<details><summary>' + esc(fill(f.q, WORDS)) + '</summary><p class="hf-faq__a">' + esc(fill(f.a, WORDS)) + '</p></details>'; }).join('');
  var T=C.terms||{};el('terms-h').textContent=T.title||'membership terms';
  el('terms-body').innerHTML='<p class="hf-eyebrow">'+esc(T.intro||'')+'</p>'+(T.sections||[]).map(function(t){return '<section><h3>'+esc(t.h)+'</h3><p>'+esc(fill(t.p,WORDS))+'</p></section>';}).join('');
  el('end-h').textContent = E.h || ''; el('end-cta').textContent = E.cta || 'shop';
}
/* The three beats, drawn with the page's own parts: the sum, the cards, the meter. */
function plate(i) {
  if (i === 0) return '<span class="hf-sum"><b>' + esc(WORDS.spend) + '</b><i>→</i><b>' + esc(WORDS.drop) + '</b></span>';
  if (i === 1) return '<span class="hf-steps">' + LEVELS.map(function (l, k) { return '<i style="--s:' + k + '">' + card(k, { bare: true }) + '</i>'; }).join('') + '</span>';
  var pips = ''; for (var p = EVERY, n = 0; p < 100; p += EVERY, n++) pips += '<i class="' + (n < 2 ? 'is-on' : '') + '" style="left:' + p + '%">' + (WORDS.drop && DROP_N ? '<b>' + esc(X.sym + DROP_N * Rewards.backAt(S, n + 1, 0, 1)) + '</b>' : '') + '</i>';
  return '<span class="hf-mini"><span class="hf-mini__fill"></span>' + pips + '<span class="hf-mini__u"></span></span>';
}
/* The last word: the card u are going for next, and how far off it is. */
function paintEnd() {
  var E = C.end || {}, K = C.levels || {}, g = !!state.guest, box = el('end-card'), nx = g ? null : LEVELS[state.level + 1];
  var words = '', about = '';
  if (g) { box.innerHTML = card('guest', { mine: true }); words = state.pending ? C.personal.sync : E.guest; }
  else if (nx) {
    box.innerHTML = card(state.level + 1); words = fill(E.next, { label: nx.label });
    about = state.orders < 1 ? K.locked_first : fill(K.locked, { money: spendTo(nx.min_pct) }) + '.';
  } else { box.innerHTML = SECRET ? card('secret') : card(state.level); words = E.top; }
  el('end-next').innerHTML = esc(words || '') + (about ? ' <em>' + esc(about) + '</em>' : '');
  el('end-login').hidden = !g || !!state.pending; el('end-login').textContent = (C.guest || {}).cta || 'join free';
  el('end-cta').classList.toggle('lp-cta--ghost', g && !state.pending);
}

/* ── THE DOCK: ur score and the next thing, once the hero is behind u ────── */
function paintDock() {
  var d = el('dock'); if (!d) return;
  var g = !!state.guest, D = C.dock || {}, l = LEVELS[state.level] || {}, w = nextWords(nextNode());
  el('dock-n').textContent = g ? D.guest_n || '??' : state.pct + '%';
  el('dock-l').textContent = state.pending ? C.personal.heading : g ? D.guest_l || '' : l.label || '';
  el('dock-x').textContent = state.pending ? C.card.syncing : g ? D.guest_x || '' : w.main;
  el('dock-login').hidden = !g || !!state.pending; el('dock-login').textContent = (C.guest || {}).cta || 'join free';
  el('dock-shop').hidden = g && !state.pending; el('dock-shop').textContent = C.shop || 'shop';
}

/* ── THE LEVEL-UP ───────────────────────────────────────────────────────── */
var upBack = null;
function levelUp(i) {
  var l = LEVELS[i], up = el('up'); if (!l || !up) return;
  el('up-card').innerHTML = card(i, { mine: true, name: state.name, since: state.since, pct: state.pct, cut: true });
  el('up-pre').textContent = (C.up || {}).pre || '';
  el('up-h').innerHTML = esc(l.label) + '<i>.</i>';
  el('up-say').textContent = (C.lede || {})[l.key] || '';
  el('up-got').setAttribute('aria-label', (C.up || {}).got || '');
  /* the label is a <li> the probe does not count (it counts [data-got]); the level's big perk leads, set large */
  el('up-got').innerHTML = '<li class="hf-up__lbl" aria-hidden="true">' + esc((C.up || {}).got || '') + '</li>' + perksAt(i).slice(0, 3).map(function (e, n) {
    var a = perkAmt(e);
    return '<li data-got class="' + (e.hero ? 'is-sig' : '') + '" style="--i:' + n + '"><span>' + esc(perkTitle(e)) + '</span>' + (a ? '<b>' + esc(a) + '</b>' : '') + '</li>';
  }).join('');
  el('up-go').textContent = (C.up || {}).go || 'carry on';
  upBack = document.activeElement; up.hidden = false; document.body.classList.add('lp-locked'); el('up-go').focus();
  refreshCardMotion();
}
function closeUp() { var up = el('up'); if (!up || up.hidden) return; up.hidden = true; document.body.classList.remove('lp-locked'); if (upBack && upBack.focus) upBack.focus(); }
function wireUp() {
  el('up-go').addEventListener('click', closeUp);
  document.addEventListener('keydown', function (e) { if (el('up').hidden) return; if (e.key === 'Escape') closeUp(); if (e.key === 'Tab') { e.preventDefault(); el('up-go').focus(); } });
}
/* A real customer sees it once, the first visit after they cross a gate. Their
   first ever visit only records where they are: nothing happened to celebrate. */
function rememberLevel() {
  if (state.guest || PREVIEW || !X.member_id) return;
  try {
    var k = 'hf:level:' + X.member_id, was = localStorage.getItem(k);
    if (was != null && state.level > +was) levelUp(state.level);
    localStorage.setItem(k, String(state.level));
  } catch (e) { /* private mode: no celebration, nothing lost */ }
}

function paintAll() { paintHero(); paintClimb(); paintMatrix(); paintEnd(); }

/* ── PREVIEW ONLY: view the page as each kind of person ────────────────── */
function buildView() {
  if (!PREVIEW) return;
  var bar = el('view'); if (!bar) return;
  bar.innerHTML = '<b>not live · view as</b>' + DEMO.map(function (d, i) {
    return '<button type="button" data-i="' + i + '" aria-pressed="false">' + esc(d.tag || (LEVELS[d.level].label.toLowerCase() + ' ' + d.pct + '%')) + '</button>';
  }).join('');
  bar.hidden = false; document.body.classList.add('hf-viewing');
  var startView = new URLSearchParams(location.search).get('hf_member'), viewNames = ['guest','starter','stray','wild','unhinged','feral','beyond','returned','syncing'], startAt = viewNames.indexOf(startView);
  if(startAt>=0){state=JSON.parse(JSON.stringify(DEMO[startAt]));state.preview=true;paintAll();}
  all('[data-hf="view"] button').forEach(function(b){b.setAttribute('aria-pressed',+b.getAttribute('data-i')===(startAt>=0?startAt:0)?'true':'false');});
  bar.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    var was = state, now = JSON.parse(JSON.stringify(DEMO[+b.getAttribute('data-i')] || DEMO[0]));
    state = now; state.preview=true;
    all('[data-hf="view"] button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    paintAll();
    if (!was.guest && !now.guest && now.level > was.level) levelUp(now.level);
  });
  /* Shopify's own preview bar is fixed to the bottom and paints OVER this one
     (MEASURED on staging: elementFromPoint on a button returned its iframe), so
     sit on top of it, and the dock sits on top of both. It arrives late and can
     be hidden, so keep measuring. */
  var lift = function () {
    var w = document.getElementById('PBarNextFrameWrapper'), h = 0;
    if (w) { var r = w.getBoundingClientRect(); if (r.height > 0 && r.height < innerHeight / 2 && r.bottom >= innerHeight - 2) h = Math.round(r.height); }
    bar.style.setProperty('--hf-view-b', h + 'px');
    var d = el('dock'); if (d) d.style.setProperty('--hf-dock-b', (h + bar.offsetHeight) + 'px');
  };
  lift(); var n = 0, iv = setInterval(function () { lift(); if (++n > 40) clearInterval(iv); }, 500);
  window.addEventListener('resize', lift);
}

/* The primary exploration action opens the member's own level. */
all('[data-hf-jump]').forEach(function(b){ b.addEventListener('click',function(){if(!state.guest)setMemberView('collection');selectLevel(state.guest?2:state.level,true);}); });

/* The kit hides the theme's marquee on a lander, but the theme's header still
   sticks 32px down to make room for it, so at the top of the page the header
   slides over our first 32px. MEASURED on stage: header [32,105], section top 73.
   Measured, never hardcoded; only at rest at the top (further down, content
   scrolling under a sticky header is the design); and it only ever grows, so the
   page cannot jitter as the header collapses.
   `--hf-chrome` is the other half: where the sticky header ends RIGHT NOW, so the
   pinned card on a desktop never slides under it. */
function clearHeader() {
  var host = document.querySelector('#lp-how-feral'), hdr = document.querySelector('header.shopify-section-group-header-group');
  if (!host || !hdr) return;
  var have = 0, last = -1, tick = 0, measure = function () {
    tick = 0;
    var r = hdr.getBoundingClientRect(), b = Math.max(0, Math.round(r.bottom));
    if (b !== last && b < 240) { last = b; host.style.setProperty('--hf-chrome', b + 'px'); }
    if (window.scrollY > 2) return;
    var over = Math.round(r.bottom - host.getBoundingClientRect().top);
    if (over > have && over < 200) { have = over; host.style.setProperty('--hf-under', over + 'px'); }
  };
  measure(); setTimeout(measure, 200); setTimeout(measure, 600);
  window.addEventListener('scroll', function () { if (!tick) tick = setTimeout(measure, 250); }, { passive: true });
  window.addEventListener('resize', measure);
}

/* A card in the stack, picked up: go and read its chapter. */
el('peeks').addEventListener('click', function (e) {
  var b = e.target.closest('button[data-peek]'); if (!b) return;
  selectLevel(b.getAttribute('data-peek'), true);
  var panel=document.querySelector('[data-ch="'+b.getAttribute('data-peek')+'"]');if(panel)panel.focus({preventScroll:true});
});

// The FERAL sign-in entry returns a real session to this membership page.
if(PREVIEW)['login','end-login','dock-login'].forEach(function(key){
 var u=new URL(el(key).href);u.pathname=u.pathname.replace(/\/pages\/your-feral$/, '/pages/contact');
 u.searchParams.set('view','your-feral');u.searchParams.set('preview_theme_id','195447554430');el(key).href=u.href;
});

buildTry(); buildClimb(); buildMatrix(); buildRest(); wireUp();
paintAll();
pointerTilt(el('mycard')); pointerTilt(el('stage')); scrollTilt();
initCardMotion();
buildView(); rememberLevel(); clearHeader();
function openTerms(){if(location.hash!=='#membership-terms')return;if(!state.guest)setMemberView('details');el('terms').querySelector('details').open=true;LP.jumpTo(el('terms'));}
window.addEventListener('hashchange',openTerms);openTerms();
if (el('dock')) { document.body.classList.add('hf-docked'); LP.dockOn(document.querySelector('#lp-how-feral .hf-hero')); }

/* Where a join came from, for the sign-ups console. The UTM tags on the link that
   brought the visitor win; without them, a coarse label for the site before, never the
   address itself or SEND IT's `fm`. Held for the tab's session, so it survives the
   Shopify sign-in, and only once analytics is allowed. Only the engine's accepted
   shape leaves: source, medium, campaign, each [-a-zA-Z0-9_]{1,80} (anything else is
   dropped, never cleaned up, so an address pasted into a tag cannot pass). The same
   function sits in how-feral/page.js and your-feral/page.js: keep them identical. */
function joinSource(){
 var KEY='feral_join_source',OK=/^[-a-zA-Z0-9_]{1,80}$/,held=null;
 function allowed(){return !!(window.Shopify&&Shopify.customerPrivacy&&Shopify.customerPrivacy.analyticsProcessingAllowed&&Shopify.customerPrivacy.analyticsProcessingAllowed());}
 function clean(v){var out={};if(v&&typeof v==='object')['source','medium','campaign'].forEach(function(k){if(typeof v[k]==='string'&&OK.test(v[k]))out[k]=v[k];});return out.source||out.medium||out.campaign?out:null;}
 function stored(){try{return clean(JSON.parse(sessionStorage.getItem(KEY)||'null'));}catch(e){return null;}}
 function referrer(){
  var h='';try{h=document.referrer?new URL(document.referrer).hostname.toLowerCase():'';}catch(e){}
  if(!h)return {source:'direct',medium:'none'};
  if(/(^|\.)(feralclo\.com|shopify\.com|myshopify\.com|shop\.app)$/.test(h))return {source:'feralclo',medium:'on-site'};
  if(h==='t.co')return {source:'x',medium:'social'};
  var labels=h.split('.'),find=function(names){for(var i=0;i<names.length;i++)if(labels.indexOf(names[i])>=0)return names[i];return null;};
  var social=find(['instagram','facebook','tiktok','youtube','snapchat','pinterest','reddit','threads','linkedin','twitter','x']);if(social)return {source:social,medium:'social'};
  var search=find(['google','bing','duckduckgo','yahoo','ecosia','brave','baidu','yandex']);if(search)return {source:search,medium:'organic'};
  return {source:'other',medium:'referral'};
 }
 var p=new URLSearchParams(location.search),tagged=clean({source:p.get('utm_source'),medium:p.get('utm_medium'),campaign:p.get('utm_campaign')});
 // Tags always speak; a referrer only for the first page of the session, so the return from sign-in never overwrites how they came.
 held=tagged||(stored()?null:referrer());
 function keep(){if(!held||!allowed())return;try{sessionStorage.setItem(KEY,JSON.stringify(held));held=null;}catch(e){}}
 keep();document.addEventListener('visitorConsentCollected',keep);
 return function(){return allowed()?held||stored():null;};
}
joinSource();

/* Member behaviour is optional analytics. The money ledger is always driven
   by signed Shopify orders, never browser clicks or claimed spend. */
(function(){
 if(!X.logged_in||(X.theme_role==='development'||X.theme_role==='unpublished')&&new URLSearchParams(location.search).has('hf_member'))return;
 var csrf=null,started=false,viewed=new Set();
 function allowed(){return !!(window.Shopify&&Shopify.customerPrivacy&&Shopify.customerPrivacy.analyticsProcessingAllowed&&Shopify.customerPrivacy.analyticsProcessingAllowed());}
 function send(type,release){
  if(!csrf||!allowed())return;
  fetch('/apps/feral-membership/events',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({csrf:csrf,type:type,event_id:crypto.randomUUID(),occurred_at:new Date().toISOString(),analytics_permission:'granted',privacy_contract:1,...(release?{release_id:release}:{})}),keepalive:true}).catch(function(){});
 }
 function observe(){document.querySelectorAll('[data-hf-release]').forEach(function(node){var id=node.dataset.hfRelease;if(!id||viewed.has(id))return;var observer=new IntersectionObserver(function(entries){if(entries.some(function(e){return e.isIntersecting;})&&allowed()){viewed.add(id);send('invitation_viewed',id);observer.disconnect();}},{threshold:.5});observer.observe(node);});}
 async function start(){if(started||!allowed())return;started=true;try{var response=await fetch('/apps/feral-membership/session',{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw Error('Session unavailable');csrf=(await response.json()).csrf;send('membership_view');observe();}catch{started=false;}}
 document.addEventListener('visitorConsentCollected',start);start();
 document.addEventListener('click',function(event){var link=event.target.closest('[data-hf-release] a');if(link)send('invitation_clicked',link.closest('[data-hf-release]').dataset.hfRelease);});
})();

})();